import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from 'vue';
import {useI18n} from 'vue-i18n'
import {useStore} from 'vuex';
import ContentContainer from '@/layout/ContentContainer.vue'
import Form from '@/components/Form.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  setup(__props) {

const langCode = computed(() => {
  return useI18n().locale
})

const store = useStore()
const content = computed(() => {
  return store.state.pageContent
})

const isMobile = computed(() => window.innerWidth < 1024)

const heroTextColor = computed(() => {
  return store.state.pageContent.header_text_color
})

const heroBkgStyle = computed(() => {
  const headerColorRgb = hexToRgb(store.state.pageContent.header_color);
  const headerAlpha = store.state.pageContent.header_alpha / 100;
  const headerImage = store.state.pageContent?.header_image?.file;

  return {
    background: `linear-gradient(0deg, rgba(${headerColorRgb}, ${headerAlpha}) 0%,
                rgba(${headerColorRgb}, ${headerAlpha}) 100%),
                url('${headerImage}') 50% / cover no-repeat`
  };
});

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return null; // Return null if the hex is invalid

  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);

  return `${r}, ${g}, ${b}`;  // Correctly format the RGB values
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "hero",
    style: _normalizeStyle([!isMobile.value ? heroBkgStyle.value : ''])
  }, [
    _createVNode(ContentContainer, { class: "hero__container" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "hero__title",
          style: _normalizeStyle([isMobile.value ? heroBkgStyle.value : ''])
        }, [
          _createElementVNode("h1", {
            class: "hero__title__text",
            style: _normalizeStyle({'color': heroTextColor.value})
          }, _toDisplayString(content.value['header_text_' + langCode.value.value] ?? ''), 5)
        ], 4),
        _createVNode(Form, { class: "hero__form" })
      ]),
      _: 1
    })
  ], 4))
}
}

})